import { useContext } from 'react';
import { createContext } from 'react';

import { TabListProps } from '../@types/TabListProps';

export const TabListContext = createContext<TabListProps>({} as TabListProps);

TabListContext.displayName = 'TabList';

const TabListProvider = (props: TabListProps) => (
	<TabListContext.Provider value={props}>{props.children}</TabListContext.Provider>
);

export const useTabList = () => {
	const context = useContext(TabListContext);

	return context;
};

export default TabListProvider;
